import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { api } from '../api';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // session_id is passed in the URL hash fragment: #session_id=xxx
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate('/login');
      return;
    }

    api.post('/auth/session', { session_id: sessionId })
      .then(user => {
        setUser(user);
        toast.success(`Bienvenue ${user.name || user.email} !`);
        navigate('/');
      })
      .catch(err => {
        const msg = err?.detail || err?.message || 'Accès refusé';
        toast.error(msg);
        navigate('/login');
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-[#0288D1] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-slate-500 text-sm">Connexion en cours...</p>
      </div>
    </div>
  );
}
